import { createContext, useContext, useEffect, useRef } from "react";

export type OpcionesAbmMode = "list" | "create" | "edit";

export type OpcionesAbmNavValue = {
  register: (mode: OpcionesAbmMode, goToList: () => void) => void;
};

export const OpcionesAbmNavContext = createContext<OpcionesAbmNavValue | null>(null);

/**
 * Reporta listado / creación / edición al breadcrumb de Opciones.
   * El trail visual es `ModuleTrail` bajo el título (`ModuleTitleBlock`).
 * `goToList` se llama al clickear el nombre del submódulo (sale de create/edit).
 */
export function useRegisterOpcionesAbmNav(
  isAbm: boolean,
  isEdit: boolean,
  goToList: () => void
) {
  const ctx = useContext(OpcionesAbmNavContext);
  const goRef = useRef(goToList);
  goRef.current = goToList;
  const mode: OpcionesAbmMode = !isAbm ? "list" : isEdit ? "edit" : "create";

  useEffect(() => {
    if (!ctx) return;
    ctx.register(mode, () => goRef.current());
  }, [ctx, mode]);

  useEffect(() => {
    if (!ctx) return;
    return () => ctx.register("list", () => {});
  }, [ctx]);
}
